// frontend/src/components/layout/mobile/MobileChrome.jsx
//
// The app's frame on a phone (768px and below, where the desktop top bar and
// sidebar hide): a top bar with the store switcher, search and the bell, and a
// bottom tab bar with the four main screens and More (mobileNav.js).
//
// Search and Contact support open overlays TopMenu owns for both layouts, so
// they come in as commands.

import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ICON, DotsThree, MagnifyingGlass } from '../../../icons';
import { PageIcon } from '../../../config/appPages';
import TabLink from '../../../tabs/TabLink';
import { MORE, TABS, litTab } from './mobileNav';
import StoreSwitcher from './StoreSwitcher';
import NotificationsButton from './NotificationsButton';
import MoreSheet from './MoreSheet';
import './MobileChrome.css';

/**
 * @param {{ onSearch: () => void, onOpenContact: () => void }} props
 */
export default function MobileChrome({ onSearch, onOpenContact }) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [moreOpen, setMoreOpen] = useState(false);
  const lit = litTab(pathname);

  return (
    <>
      <header className="mobile-top-bar">
        <StoreSwitcher />
        <div className="mobile-top-bar__actions">
          <button
            type="button"
            className="mobile-top-bar__icon"
            onClick={onSearch}
            aria-label={t('commandPalette.title')}
          >
            <MagnifyingGlass size={ICON.xxl} />
          </button>
          <NotificationsButton />
        </div>
      </header>

      <nav className="mobile-tab-bar" aria-label={t('mobileNav.tabBar')}>
        {TABS.map((tab) => {
          const active = lit === tab.path;
          return (
            <TabLink
              key={tab.path}
              to={tab.path}
              className={`mobile-tab${active ? ' mobile-tab--active' : ''}`}
              aria-current={active ? 'page' : undefined}
            >
              <PageIcon path={tab.path} size={ICON.xxl} weight={active ? 'fill' : 'regular'} />
              <span className="mobile-tab__label">{t(tab.labelKey)}</span>
            </TabLink>
          );
        })}
        <button
          type="button"
          className={`mobile-tab${lit === MORE ? ' mobile-tab--active' : ''}`}
          aria-haspopup="dialog"
          aria-expanded={moreOpen}
          onClick={() => setMoreOpen(true)}
        >
          <DotsThree size={ICON.xxl} weight="bold" />
          <span className="mobile-tab__label">{t('mobileNav.more')}</span>
        </button>
      </nav>

      <MoreSheet open={moreOpen} onClose={() => setMoreOpen(false)} onOpenContact={onOpenContact} />
    </>
  );
}
